import { FC } from 'react';
import { Center, Controls, Footer, Header, Layout, Left, Main, MainLayout, Right } from '../Components/Layout';

export type LoginProps = {
  onSignIn: () => void;
  goToDocumentAcceptance: () => void;
};

export const Login: FC<LoginProps> = ({ onSignIn, goToDocumentAcceptance }) => (
  <Layout>
    <Header />
    <Main>
      <MainLayout>
        <Left />
        <Center>
          <h1>Lead-Advisor Hire Calling</h1>
          <Controls>
            <button onClick={onSignIn}>Sign In</button>
            <button onClick={goToDocumentAcceptance}>Sign Up</button>
          </Controls>
        </Center>
        <Right />
      </MainLayout>
    </Main>
    <Footer />
  </Layout>
);
